export const BUSINESS_SOLUTIONS_PAGE_ROUTE = '/business-solutions';
export const BROADCAST_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/broadcast-production`;
export const AGENCIES_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/agencies`;
export const EDUCATION_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/education`;
export const MARKETING_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/marketing`;
export const MEDIA_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/media`;
export const LICENSE_COMPARISON_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/license-comparison`;
export const API_PAGE_ROUTE = `${BUSINESS_SOLUTIONS_PAGE_ROUTE}/api`;
